import { createOutlookSpace } from 'owa-timestream-service';
import type { NewOutlookSpace } from 'owa-timestream-types';
import { timeStreamProjectCreated } from '../actions';
import { setDefaultProjectLoadState } from '../mutators/defaultProjectLoadStateMutators';
import { DefaultProjectLoadState } from '../schema/DefaultProjectLoadState';
import hasSelectedProject from '../selectors/hasSelectedProject';
import * as trace from 'owa-trace';

export default async function createTimeStreamProject(
    targetMailbox: string,
    newProject: NewOutlookSpace
) {
    const hasSelected = hasSelectedProject();
    try {
        const newOutlookSpace = await createOutlookSpace(newProject, targetMailbox);
        // for new users to caledar board, they wil not have a selected project. If a user were to direct url to an existing
        // project from Moca into calendar board, this condition will not be met, should clean this up with VSO: 118243
        if (!hasSelected) {
            setDefaultProjectLoadState(DefaultProjectLoadState.SuccessCreateNew);
        }
        timeStreamProjectCreated(targetMailbox, newOutlookSpace);
    } catch (e) {
        if (!hasSelected) {
            trace.errorThatWillCauseAlert('Failed to create board project', e);
            setDefaultProjectLoadState(DefaultProjectLoadState.ErrorCreateNew);
        }
    }
}
